module.exports = __webpack_public_path__ + "media/applicants/usatoday-28d0c871.png";